import React from "react";
import { RBACHidden } from "../../../helpers/rbac/rbac";
import { useHistory } from "react-router-dom";

import { ServiceProviderR } from "../../../pages/service-provider/routes";
import { ProcManagementR } from "../../../pages/proc-management/route";
import { PrimaryButton } from "@graffer-inc/console-design-kit";

export const MainMenu: React.FC<{
  orgId: string;
  isServiceProviderAccount?: boolean;
}> = ({ orgId, isServiceProviderAccount = false }) => {
  const history = useHistory();
  const createLink = isServiceProviderAccount
    ? ServiceProviderR.ProcManagementPlaceCreate.link({ orgId })
    : ProcManagementR.PlaceCreate.link({});
  return (
    <div className="columns">
      <div className="column has-text-right buttons">
        <RBACHidden requirePermissions="proc_management.places.create">
          <PrimaryButton
            text={"場所データ新規作成"}
            onClick={() => {
              history.push(createLink);
            }}
          />
        </RBACHidden>
      </div>
    </div>
  );
};
